<template>
  <section class="about-cover">
    <div class="about-cover__content">
      <div class="about-cover__image-container">
        <ImgLazy
          :image-url="AboutCoverImage"
          alt-text=""
          aspect-ratio="128 / 85"
          image-class="about-cover__image"
        />
      </div>
      <div class="about-cover__description-area">
        <div class="about-cover__logo">
          <Logo />
        </div>
        <div class="about-cover__description">
          <p class="about-cover__description-paragraph">
            <span class="about-cover__description-span">
              gifteeは本名や住所を知らない相手にも
            </span>
            <span class="about-cover__description-span">
              SNSやメールなどオンラインで
            </span>
            <span class="about-cover__description-span">
              ギフトを贈れるサービスです。
            </span>
          </p>
          <p class="about-cover__description-paragraph">
            <span class="about-cover__description-span">
              ありがとう、おつかれさま、おめでとう、
            </span>
            <span class="about-cover__description-span">
              心に浮かんだキモチを
            </span>
            <span class="about-cover__description-span">
              あなたも気軽に贈ってみませんか？
            </span>
          </p>
          <p class="about-cover__description-paragraph">
            <span class="about-cover__description-span">
              ちゃんと伝えられたら、
            </span>
            <span class="about-cover__description-span">
              うれしいのは相手以上に、自分かもしれません。
            </span>
          </p>
        </div>
        <div class="about-cover__headline">そのキモチ、贈ってみよう。</div>
      </div>
    </div>
  </section>
</template>

<script setup>
import ImgLazy from '../../../atoms/images/ImgLazy.vue'
import Logo from '../../../atoms/svg_icons/Logo.vue'
import AboutCoverImage from '../../../../../../images/abouts/cover/about-top_rgb.png'
</script>

<style lang="scss" scoped>
.about-cover {
  display: flex;
  justify-content: center;

  &__content {
    display: flex;
    max-width: 1440px;
    width: 100%;
    padding: 96px 72px;
    gap: 32px;
    align-items: center;
    justify-content: center;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 48px 24px;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      flex-direction: column;
    }
  }

  &__image-container {
    flex: 1;

    @media all and (max-width: ($base-contents-width - 1)) {
      max-width: 100%;
      width: 100%;
    }
  }

  &__image {
    object-fit: contain;
  }

  &__description-area {
    display: flex;
    flex-direction: column;
    gap: 32px;
    text-align: left;
  }

  &__description {
    @extend %title;
    line-height: 1.46;
    display: flex;
    flex-direction: column;
    gap: calc(1.8rem * 1.46);

    @media all and (max-width: ($pc-width - 1)) {
      font-size: 1.4rem;
      gap: calc(1.4rem * 1.46);
      width: 344px;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      width: auto;
    }
  }

  &__logo {
    svg {
      width: 248px;
      height: 75px;

      @media all and (max-width: ($pc-width - 1)) {
        width: 106px;
        height: 32px;
      }
    }
  }

  &__description-span {
    display: block;
  }

  &__headline {
    font-size: 3.2rem;
    line-height: 1.6;
    color: $primary;

    @media all and (max-width: ($pc-width - 1)) {
      font-size: 2.4rem;
    }
  }
}
</style>
